import React from 'react';
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button';
import { useEffect } from 'react'
import { Separator } from '@/components/ui/separator';


function Docu() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>


<div className='mx-auto items-center my-6 font-gotham text-medium p-2'>
<div className='my-6 max-w-prose text-center mx-auto'>
{/*       <tag className="font-gotham text-background bg-black rounded-full px-4 py-2 text-bold">Jaar 1</tag> */}
          <h1 className=''>Ik ben Jo: Documentaire</h1>

</div>

<div className="mb-2 mx-auto max-w-4xl rounded-2xl overflow-hidden">
  <div className="relative w-full h-0 pb-[56.25%]"> 
    <iframe
      className="absolute top-0 left-0 w-full h-full rounded-2xl"
      src="https://www.youtube.com/embed/sSyWxNn-TIU?si=Om8_2TiN8Y0cl12n"
      title="YouTube video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerPolicy="strict-origin-when-cross-origin"
      allowFullScreen
    ></iframe>
  </div>
  <p className='font-gotham text-xs p-2 px-6'>video: Mals Media</p>
</div>

</div>
    </>
  );
}

export default Docu;